
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useHistory } from "react-router-dom";
import LayoutWithOutAccountCard from "../Layout/layout-without-card";
import { OTHER_SUB_MENUS } from "../Layout/menu-names";
import { getMenuListSelector } from "../../store/selectors/app.selector";
import { useSelector } from 'react-redux'

export default function AdditionalLinks() {
  const history = useHistory();
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['OTHER_SERVICES'] || {}
  return (
    <LayoutWithOutAccountCard
      breadCumKey="ADDITIONAL_LINKS"
      keyPath={"OTHER_SERVICES"}
      showEmptySpace={true}
    >
      <Row>
        {Object.keys(menuConfig).length>0 && OTHER_SUB_MENUS.map((option, index) => (
          <>
          {menuConfig[option.key] && 
          (<Col
            onClick={() => history.push(option.link)}
            xs={"auto"}
            sm={"auto"}
            md={"auto"}
            key={index}
            className="account-menu-card"
          >
            <img width={52} height={40} src={option.icon} />
            <h2>{t(option.title)}</h2>
            <span>{t(option.desc)}</span>
          </Col>
        )}
        </>
        ))}
      </Row>
    </LayoutWithOutAccountCard>
  );
}
